import { jsx } from 'react/jsx-runtime';
import { InputText } from '@dls/web';
import { setMaxLengthPropsAndRules, isRuleValidationRequired, getRuleValidationMessage, buildErrorMessage } from './helpers/utils.js';
import CustomController from './CustomController.js';
import { REGEXP_EMAIL, VALIDATION_MSG, validateNRIC } from '@geit/helpers';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};
const InputTextController = _a => {
  var _b = _a,
    {
      name,
      control,
      defaultValue,
      rules: rulesRaw,
      shouldUnregister,
      isDigit
    } = _b,
    inputTextProps = __objRest(_b, ["name", "control", "defaultValue", "rules", "shouldUnregister", "isDigit"]);
  const {
    bgColor = "haze",
    label,
    maxLength: maxLengthRaw,
    type
  } = inputTextProps;
  const {
    rules,
    maxLength
  } = setMaxLengthPropsAndRules(rulesRaw, maxLengthRaw);
  if (rules) {
    if (isRuleValidationRequired(rules.email)) {
      rules.pattern = {
        value: REGEXP_EMAIL,
        message: getRuleValidationMessage(rules.email) || VALIDATION_MSG.EMAIL
      };
    } else if (isRuleValidationRequired(rules.nric)) {
      rules.validate = value => validateNRIC(value, getRuleValidationMessage(rules.nric));
    }
  }
  const handleKeyDown = e => {
    const exceptedCharacters = ["e", "E", "+", "-", "."];
    if (type === "number" && isDigit && exceptedCharacters.includes(e.key)) {
      e.preventDefault();
    }
  };
  return /* @__PURE__ */jsx(CustomController, {
    name,
    control,
    defaultValue,
    rules,
    shouldUnregister,
    render: _ref => {
      let {
        field,
        fieldState: {
          error
        }
      } = _ref;
      if ((error == null ? void 0 : error.type) === "pattern" && (rules == null ? void 0 : rules.email)) {
        error.type = "email";
      }
      const errorMessage = buildErrorMessage({
        error,
        label,
        rules
      });
      return /* @__PURE__ */jsx(InputText, __spreadProps(__spreadValues(__spreadValues({}, field), inputTextProps), {
        type,
        bgColor,
        maxLength,
        error: !!errorMessage,
        hintMessage: errorMessage,
        onKeyDown: handleKeyDown
      }));
    }
  });
};
export { InputTextController as default };